import React, { useRef, useLayoutEffect } from 'react';

export default function ScrollIntoView() {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    ref.current?.scrollIntoView();
  });
  return <div ref={ref} />;
}
